import React from 'react';
import { Button } from '@tviklax/ui-components';
import styled from 'styled-components';

const ReviewActions = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  margin-top: 1rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    flex-direction: column;

    button {
      width: 100%;
    }
  }
`;

interface ReviewExtractedDataProps {
  onConfirm: () => void;
  onEdit?: () => void;
  secondaryActionLabel?: string;
  confirmDisabled?: boolean;
  confirmDisabledReason?: string;
}

export const ReviewExtractedData: React.FC<ReviewExtractedDataProps> = ({
  onConfirm,
  onEdit,
  secondaryActionLabel,
  confirmDisabled,
  confirmDisabledReason,
}) => {
  return (
    <div>
      <ReviewActions>
        {onEdit && (
          <Button variant="outline" onClick={onEdit}>
            {secondaryActionLabel || 'Edit Manually'}
          </Button>
        )}
        <Button onClick={onConfirm} disabled={confirmDisabled}>
          Confirm & Create Order
        </Button>
      </ReviewActions>
      {confirmDisabled && confirmDisabledReason && (
        <div style={{ textAlign: 'right', fontSize: 13, color: '#b45309', marginTop: '0.5rem' }}>
          {confirmDisabledReason}
        </div>
      )}
    </div>
  );
};
